import React from 'react';
import { Step, StepLabel, Stepper } from '@mui/material';
import { styled } from '@mui/material/styles';
import StepConnector, {
    stepConnectorClasses,
} from '@mui/material/StepConnector';
import CircleIcon from '@mui/icons-material/Circle';
import variables from '../../../stylesheets/variables.module.scss';
import { PROGRESS_STEP } from '../../../types/properties/propertyTypes';
import useTranslate from '../../../customHooks/useTranslate';

interface TabsProps {
    tabs: { title: string; tabNumber: number }[];
    activeStep: PROGRESS_STEP;
    activeTab: number;
    lastCompletedTab: number;
    onTabChange: (step: PROGRESS_STEP, tab: number) => void;
}

const Tabs = (props: TabsProps) => {
    const { tabs, activeStep, activeTab, lastCompletedTab, onTabChange } =
        props;
    const translate = useTranslate();

    const StyledStepConnector = styled(StepConnector)(() => ({
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
            // top: 22,
        },
        [`&.${stepConnectorClasses.active}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                backgroundColor: variables.grey200,
            },
        },
        [`&.${stepConnectorClasses.completed}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                height: 1.5,
                backgroundColor: variables.grey700,
            },
        },
        [`& .${stepConnectorClasses.line}`]: {
            height: 1,
            border: 0,
            backgroundColor: variables.grey200,
        },
    }));

    const StepIcon = (_props: any) => {
        const { icon } = _props;
        const active = icon === activeTab;
        const completed = icon <= lastCompletedTab;
        return (
            <CircleIcon
                style={{
                    width: active ? '14px' : '10px',
                    height: active ? '14px' : '10px',
                    color: active
                        ? variables.grey950
                        : completed
                        ? variables.grey700
                        : variables.grey200,
                    cursor: completed || active ? 'pointer' : 'auto',
                    margin: 0,
                }}
                onClick={() =>
                    (completed || active) && onTabChange(activeStep, icon)
                }
            />
        );
    };

    return (
        <nav className='tabs__section'>
            <div className='tabs__container'>
                <Stepper
                    sx={{ width: '100%' }}
                    alternativeLabel
                    activeStep={activeTab}
                    connector={<StyledStepConnector />}
                >
                    {tabs.map(tab => {
                        const isActive = tab.tabNumber === activeTab;
                        const completed = tab.tabNumber <= lastCompletedTab;
                        return (
                            <Step
                                key={tab.tabNumber}
                                // active={tab.tabNumber === activeTab}
                            >
                                <StepLabel
                                    StepIconComponent={StepIcon}
                                    sx={{
                                        '& .MuiStepLabel-label.MuiStepLabel-alternativeLabel':
                                            {
                                                lineHeight: 1,
                                                color: isActive
                                                    ? variables.grey950
                                                    : completed
                                                    ? variables.grey700
                                                    : variables.grey200,
                                                fontWeight: isActive
                                                    ? 600
                                                    : 400,
                                                transition: 'color 0.3s ease',
                                                cursor:
                                                    isActive || completed
                                                        ? 'pointer'
                                                        : 'auto',
                                                marginTop: isActive
                                                    ? '4px'
                                                    : '8px',
                                            },
                                    }}
                                    onClick={() =>
                                        (isActive || completed) &&
                                        onTabChange(activeStep, tab.tabNumber)
                                    }
                                >
                                    {translate(tab.title)}
                                </StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
            </div>
        </nav>
    );
};

export default Tabs;
